import { concatMap, map, Observable, tap } from 'rxjs';
import { Component, Input, input, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

import { MessageService } from '../../core/services/message.service';
import { PagedList } from '../../core/models/paged-list';
import { Message } from '../../core/models/message';
import { MatterService } from '../../core/services/matter.service';
import { Router, UrlTree } from '@angular/router';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MessageListService } from '../../core/services/message-list.service';

@Component({
  selector: 'app-inbox-list',
  templateUrl: './inbox-list.component.html',
  styleUrl: './inbox-list.component.scss',
})
export class InboxListComponent implements OnInit {
  pagedMessages?: PagedList<Message>;
  ureadMessages: Message[] = [];
  totalUnreadMessageCount: number = 0;
  loading = false;
  newMessageText = InboxListComponent.getNewMessageText(false);
  defaultPageSize: number = 5;
  defaultPage: number = 1;

  dataSource = new MatTableDataSource(this.pagedMessages?.items);

  @Input() matterId?: string;
 @ViewChild(MatPaginator) paginator!: MatPaginator;
  pageEvent: PageEvent | undefined;
  pageSize: number = 5;
  pageIndex: number = 0;

  constructor(private bpObserver: BreakpointObserver, private messageListService: MessageListService, private router: Router) {
    
    this.bpObserver.observe(Breakpoints.XSmall).subscribe(result => {
      this.newMessageText = InboxListComponent.getNewMessageText(result.matches);
    });



  }


  ngOnInit(): void {

       this.messageListService.inboxMessages$.subscribe((messages) => {
        this.pagedMessages = messages;
        this.dataSource.data = messages.items;
        this.ureadMessages = this.pagedMessages.items.filter(m => m.timeFirstRead == null);
        
    });

    this.messageListService.unreadMessageCount$.subscribe((messages) => {
       this.totalUnreadMessageCount = messages;
    });

    // Subscribe to loading state
      this.messageListService.loading$.subscribe((loading) => {
      this.loading = loading;
    });

    // need to refresh on init for home page in case the user has gone to the next page on the inbox screen
    if(this.isHomePage()){
      this.refreshMessages();
    }
    else{
    // Get messages on initialization, if messages have already been retrieved this will not make another call
    this.messageListService.getInboxMessages(this.matterId, this.pageIndex + 1, this.pageSize);
    this.messageListService.getUnreadMessages();
    }
  }

 refreshMessages(): void {
    //force a refresh
    this.messageListService.refreshInboxMessages(this.matterId, this.pageIndex + 1, this.pageSize);
    this.messageListService.refreshUnreadMessages();
  }

 
  isInboxPage() : boolean {
     if(this.router.url === '/inbox') {
      return true;
    }
    return false;
  }
  
   
  isHomePage() : boolean {
     if(this.router.url === '/home') {
      return true;
    }
    return false;
  }

  static getNewMessageText(abbreviate: boolean) : string {
    return abbreviate ? 'New' : 'New Message';
  }

      handlePageEvent(e: PageEvent) {
      this.pageEvent = e;
      this.pageSize = e.pageSize;
      this.pageIndex = e.pageIndex;
      this.messageListService.refreshInboxMessages(this.matterId, e.pageIndex + 1, e.pageSize);
      this.messageListService.refreshUnreadMessages();
    }
  
    getComposeMessageRouterLink() : UrlTree {

     return this.router.createUrlTree(['/message-compose'], { queryParams: { returnUrl: this.router.url } });
     
    }

}
